// Mensagens programadas (30-out-2026): o cartão da acomodação com as mensagens que saem sozinhas
// para cada reserva. Painel: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Mensagens programadas",
    sub: "O que o hóspede recebe, desde a reserva até depois de sair.",
    new: "Nova mensagem",
  },
  loadError: "Não foi possível carregar as mensagens.",
  retry: "Tentar novamente",
  cancel: "Cancelar",
  noName: "Sem nome",
  tabs: { mensajes: "Mensagens", proximos: "Próximos envios", historial: "Histórico" },
  stages: { antes: "Antes da chegada", durante: "Durante a estadia", despues: "Depois da saída" },
  when: {
    entrada: "check-in",
    salida: "check-out",
    sameDay: "No dia do {momento}, às {hora}",
    before: "{n} dia antes do {momento}, às {hora} | {n} dias antes do {momento}, às {hora}",
    after: "{n} dia depois do {momento}, às {hora} | {n} dias depois do {momento}, às {hora}",
  },
  channels: { email: "E-mail", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Todas", directa: "Diretas", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Outros canais" },
  status: {
    pendiente: "Em andamento",
    enviado: "Enviado",
    en_cola: "Aguardando aceitação",
    fallo: "Não saiu",
    sin_contacto: "Sem dados de contato",
    cancelado: "Cancelado",
  },
  errors: {
    canal_reserva_no_encontrada: "O canal não encontrou esta reserva. Ela pode não existir mais ou o chat pode estar indisponível.",
    canal_sin_permiso: "O canal não autorizou o envio. Verifique a conexão deste alojamento.",
    canal_no_responde: "O canal não respondeu naquele momento.",
    canal_rechazo: "O canal não aceitou a mensagem.",
    whatsapp_numero_invalido: "O número não é válido ou não tem WhatsApp.",
    whatsapp_rechazo: "O WhatsApp não aceitou a mensagem.",
    correo_fallido: "O e-mail não pôde ser entregue.",
    envio_fallido: "Não foi possível concluir o envio.",
    envio_interrumpido: "O envio foi interrompido antes de terminar.",
    sin_telefono: "A reserva não tem um telefone válido.",
    sin_correo: "A reserva não tem e-mail próprio. O das OTAs é um alias.",
    sin_chat_ota: "A reserva não vem de uma OTA com chat.",
    mensaje_borrado: "A mensagem foi excluída antes do envio.",
    mensaje_desactivado: "A mensagem foi desativada antes do envio.",
    reserva_cancelada: "A reserva foi cancelada antes do envio.",
    alojamiento_no_existe: "O alojamento não existe mais.",
    mensaje_vacio: "A mensagem ficou vazia.",
    ya_no_tocaba: "Quando o hóspede aceitou, já não cabia entregá-la.",
  },
  unitScope: {
    sub: "Só para {name}. As do anúncio também chegam, a menos que você as altere ou desative aqui.",
    inherited: "Do anúncio",
    replaces: "Substitui a do anúncio",
    removed: "Desativada nesta unidade",
    offInListing: "Desativada no anúncio",
    differentIn: "Diferente em: {names}",
    customize: "Alterar só nesta unidade",
    turnOff: "Não enviar «{name}» nesta unidade",
    confirmRestore: "Excluir? A do anúncio voltará a ser enviada.",
    ownUnits: "Estas unidades também têm mensagens próprias: {names}. Edite-as em cada unidade.",
    replaceHint: "Mesmo nome de uma do anúncio: nesta unidade, será enviada esta no lugar dela.",
  },
  clone: {
    button: "Clonar",
    rowAction: "Clonar para outra propriedade ou unidade",
    titleAll: "Clonar para outras propriedades ou unidades",
    bring: "Trazer de outra",
    bringTitle: "Trazer mensagens de outra propriedade ou unidade",
    bringNoun: "as mensagens programadas",
    titleOne: "Clonar «{name}»",
    subtitle: "São copiados o texto, os canais, os filtros e os arquivos. Se lá houver uma mensagem com o mesmo nome, ela é atualizada; as demais não mudam. As ativas começarão a ser enviadas no horário local de cada propriedade.",
    nounAll: "a mensagem programada | as {n} mensagens programadas",
    nounOne: "a mensagem «{name}»",
    done: "Copiado para {n} acomodação: {nuevos} novas e {actualizados} atualizadas. | Copiado para {n} acomodações: {nuevos} novas e {actualizados} atualizadas.",
    skipped: {
      limite: "{names}: já tem o máximo de mensagens e «{msgs}» não coube.",
      archivo: "{names}: falta um arquivo de «{msgs}». Envie-o novamente aqui e clone outra vez.",
      error: "{names}: não foi possível copiar «{msgs}».",
    },
  },
  timeline: {
    booked: "Reserva confirmada",
    bookedHint: "Se reservar quando um momento já passou, essa mensagem não é enviada.",
    checkin: "Dia de entrada",
    checkout: "Dia de saída",
    use: "Usar",
    add: "+ Adicionar mensagem aqui",
    offset: {
      sameDay: "Nesse dia",
      before: "{n} dia antes | {n} dias antes",
      afterCheckin: "{n} dia depois | {n} dias depois",
      beforeCheckout: "{n} dia antes de sair | {n} dias antes de sair",
      after: "{n} dia depois | {n} dias depois",
    },
  },
  presets: {
    week: { name: "Falta uma semana", text: "Olá {nombre}, falta pouco para a sua estadia em {alojamiento}. Esperamos você em {entrada}. Se precisar de algo antes de chegar, escreva para nós." },
    three: { name: "Prepare a sua chegada", text: "Olá {nombre}, em 3 dias receberemos você em {alojamiento}. O check-in é a partir das {hora_entrada}. Aqui está tudo sobre a sua estadia: {enlace_portal}" },
    arrival: { name: "Hoje é a sua chegada", text: "Olá {nombre}, hoje esperamos você em {alojamiento} a partir das {hora_entrada}. Boa viagem!" },
    firstNight: { name: "Primeira noite", text: "Olá {nombre}, esperamos que você já esteja instalado em {alojamiento}. Está tudo bem? Se precisar de algo, responda a esta mensagem." },
    lastDay: { name: "Dia de saída", text: "Olá {nombre}, hoje termina a sua estadia em {alojamiento}. Lembre-se de que o check-out é até as {hora_salida}. Obrigado por ficar conosco." },
    after: { name: "Obrigado pela visita", text: "Olá {nombre}, obrigado pela sua estadia em {alojamiento}. Esperamos vê-lo novamente em breve." },
  },
  row: {
    files: "{n} arquivo | {n} arquivos",
    sent: "{n} enviada | {n} enviadas",
    queued: "{n} aguardando",
    failed: "{n} sem sair",
    duplicate: "Duplicar",
    delete: "Excluir",
    confirmDelete: "Excluir esta mensagem?",
    yesDelete: "Sim, excluir",
    copyOf: "Cópia de {name}",
  },
  upcoming: {
    arrives: "Chega em {fecha}",
    leaves: "Sai em {fecha}",
    note: "O que sairá nos próximos 30 dias com as reservas de hoje. Riscado: essa reserva não pode ser alcançada por essa via.",
    empty: "Não há envios previstos para os próximos 30 dias.",
    when: "Quando",
    guest: "Hóspede",
    message: "Mensagem",
    channels: "Vias",
    needsCheckin: "Somente se concluir o check-in",
    noReach: "Sem dados para esta via",
  },
  history: {
    empty: "Ainda não saiu nenhuma mensagem.",
    when: "Data",
    result: "Resultado",
    prev: "Anterior",
    next: "Seguinte",
  },
  vars: {
    nombre: "Nome",
    alojamiento: "Acomodação",
    entrada: "Data de entrada",
    salida: "Data de saída",
    hora_entrada: "Hora de entrada",
    hora_salida: "Hora de saída",
    codigo: "Código da reserva",
    enlace_portal: "Link do portal",
    enlace_tienda: "Link da loja",
  },
  form: {
    newTitle: "Nova mensagem",
    editTitle: "Editar mensagem",
    name: "Nome interno",
    namePh: "Ex.: Prepare a sua chegada",
    when: "Quando é enviada",
    type: { antes: "Antes do", dia: "No mesmo dia do", despues: "Depois do" },
    days: "Dias",
    reference: "Referência",
    theDayOf: "Dia do",
    anchor: { entrada: "Check-in", salida: "Check-out" },
    time: "Hora",
    timeIn: "horário de {zone}",
    timeEach: "no horário local de cada alojamento: {zones}",
    noZone: "{names}: sem país definido não sabemos o horário, então as mensagens não sairão ali. Informe-o na localização do alojamento.",
    localTime: "hora da acomodação",
    duringHint: "Se a estadia for mais curta e nesse dia o hóspede já não estiver, ela não é enviada.",
    channels: "Por onde é enviada",
    channelShort: { email: "Só com e-mail próprio", whatsapp: "Modelo após 24 h", ota: "Chat da reserva" },
    previewShort: "Pré-visualização",
    previewFrom: "Mensagem de",
    channelHint: {
      email: "Somente em reservas com e-mail próprio. O e-mail que as OTAs fornecem é um alias, então nele não sai.",
      whatsapp: "Se passaram mais de 24 h ou não há conversa, enviamos o modelo de contato e a mensagem chega ao hóspede quando ele aceitar. Com um número falso nada é enviado.",
      ota: "Pelo chat da OTA, somente em reservas desse canal. Os arquivos vão como link.",
    },
    bookings: "Para quais reservas",
    onlyCheckin: "Somente se já concluiu o check-in",
    message: "Mensagem",
    messagePh: "Escreva a mensagem que o hóspede receberá",
    translate: "Traduzir para os demais idiomas",
    translating: "Traduzindo…",
    translated: "Traduzido para os demais idiomas.",
    translatePartial: "{n} idiomas não puderam ser traduzidos. Revise-os.",
    storeHint: "A loja interna precisa de um check-in concluído; até lá, o link leva ao portal do hóspede, de onde se chega a ela. Com loja externa, vai direto.",
    fallbackHint: "É enviada no idioma do hóspede. Se esse idioma não estiver escrito, vai em espanhol ou no primeiro disponível.",
    subject: "Assunto do e-mail (opcional)",
    subjectPh: "Se deixar vazio: Mensagem da sua acomodação",
    files: "Fotos, vídeos e documentos",
    addFile: "Adicionar arquivo",
    uploading: "Enviando…",
    filesHint: "Fotos JPG ou PNG até {img} MB, PDF até {pdf} MB, XML até {xml} MB e vídeos MP4 ou 3GP (H.264) até {video} MB. O WhatsApp não aceita XML como arquivo: lá ele vai como link. Por e-mail vai anexado.",
    fileTooBig: "“{name}” excede o limite de {max} MB.",
    uploadError: "Não foi possível enviar o arquivo.",
    active: "Ativa",
    inactive: "Desativada",
    save: "Salvar",
    saving: "Salvando…",
    saved: "Mensagem salva.",
    saveError: "Não foi possível salvar. Tente novamente.",
    errName: "Dê um nome à mensagem.",
    errChannels: "Escolha pelo menos uma via de envio.",
    errTime: "Informe a hora de envio.",
    errText: "Escreva a mensagem em pelo menos um idioma.",
    preview: "Pré-visualização com dados de exemplo",
    previewEmpty: "Aqui você verá a mensagem.",
  },
};
